import { useTranslations } from 'next-intl';

import SubscribeIcon from '@/fo/icons/base/icons/subscribe24.svg';
import { UiKitButtonBase } from '@/fo/ui/kit/button/base';

import { styles } from './UiProductButtonSubscribe.styles';

type NativeElement = React.HTMLAttributes<HTMLDivElement>;

export interface UiProductButtonSubscribeProps {
  className?: string;
  onClick?: NativeElement['onClick'];
}

/**
 * Компонент кнопка купить для плиток
 *
 * Необходимо указать класс group/tile для всей плитки,
 * чтобы при наведении на неё кнопка купить становилась видимой
 */
export function UiProductButtonSubscribe({
  className,
  onClick
}: UiProductButtonSubscribeProps) {
  const t = useTranslations();
  const slots = styles();

  return (
    <div
      className={slots.base({ className })}
      onClick={onClick}
    >
      <div className={slots.title()}>{t('subscribe')}</div>
      <UiKitButtonBase
        className={slots.button()}
        rounded="full"
      >
        <SubscribeIcon />
      </UiKitButtonBase>
    </div>
  );
}
